import { BasePlugin } from 'easepick/base-plugin';
import { DateTime } from 'easepick/datetime';

export class ShowOffsetDaysPlugin extends BasePlugin {
	getName() {
		return 'ShowOffsetDaysPlugin';
	}

	/**
	* Méthode appelée juste après que le plugin soit “attaché”.
	* Ici, on récupère l’instance du datepicker.
	*/
	onAttach() {
	  let renderCount = 0;

	  this.picker.on('render', (evt) => {
		const jsDate = evt?.detail?.date;
		if (!jsDate) return;

		renderCount++;

		const index = (renderCount % 2 === 1) ? 1 : 0;

		let date = new DateTime(jsDate);

		if (index === 1) {
		  date = date.subtract(1, 'month');
		}

		const daysGrid = this.getCalendarDaysView(date);

		const allGrids = this.picker.ui.container
		  .querySelectorAll('.calendars .calendar .days-grid');

		const dayGridContainer = allGrids[index];
		if (!dayGridContainer) return;

		dayGridContainer.innerHTML = '';
		dayGridContainer.appendChild(daysGrid);
	  });
	}

	/**
	* Méthode qui génère la grille des jours d’un mois donné.
	* - `date` est positionné sur le 1er jour du mois (sous forme de `DateTime`).
	* - Nous affichons ici :
	*   1) Les jours “offset” du mois précédent
	*   2) Les jours du mois courant
	*   3) Les jours “offset” du mois suivant
	*/
	getCalendarDaysView(date) {
		const element = document.createDocumentFragment();
		const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
		const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
		const offsetDaysBefore = this.calcOffsetDays(date, this.picker.options.firstDay);
		const offsetDaysAfter = 6 - this.calcOffsetDays(new DateTime(lastDayOfMonth), this.picker.options.firstDay)
		const totalDays = 32 - new Date(date.getFullYear(), date.getMonth(), 32).getDate();
	
		for (let idx = offsetDaysBefore; idx > 0; idx--) {
		  const offsetDay = document.createElement('div');
		  offsetDay.className = 'day offset';
		  if (this.picker.options.showOffsetDays) {
			offsetDay.innerText = new DateTime(firstDayOfMonth).subtract(idx, "day").getDate().toString();
		  }
		  element.appendChild(offsetDay);
		}
	
		for (let idx = 1; idx <= totalDays; idx++) {
		  date.setDate(idx);
	
		  const calendarDay = this.getCalendarDayView(date);
	
		  element.appendChild(calendarDay);
	
		  this.picker.trigger('view', { date, view: 'CalendarDay', target: calendarDay });
		}
	
		if(this.picker.options.showOffsetDays) {
		  for (let idx = 0; idx < offsetDaysAfter; idx++) {
			const offsetDay = document.createElement('div');
			offsetDay.className = 'day offset';
			if (this.picker.options.showOffsetDays) {
			  offsetDay.innerText = new DateTime(lastDayOfMonth).add(idx + 1, "day").getDate().toString();
			}
			element.appendChild(offsetDay);
		  }
		}
	
		return element;
	}
  
 	getCalendarDayView(date) {
		const optionsDate = this.picker.options.date ? new DateTime(this.picker.options.date) : null;
		const today = new DateTime();

		const element = document.createElement('div');
		element.className = 'day unit';
		element.innerHTML = date.format('D');
		element.dataset.time = String(date.getTime());

		if (date.isSame(today, 'day')) {
		  element.classList.add('today');
		}

		if ([0, 6].includes(date.getDay())) {
		  element.classList.add('weekend');
		}

		if (this.picker.datePicked.length) {
		  if (this.picker.datePicked[0].isSame(date, 'day')) {
			element.classList.add('selected');
		  }
		} else {
		  if (optionsDate && date.isSame(optionsDate, 'day')) {
			element.classList.add('selected');
		  }
		}

		this.picker.trigger('view', { date, view: 'CalendarDay', target: element });

		return element;
	}

	/**
	* Calcul du “décalage” à afficher avant le 1er jour,
	* en tenant compte de `this.picker.options.firstDay`.
	*/
	calcOffsetDays(date, firstDay) {
		let total = date.getDay() - firstDay;
		if (total < 0) total += 7;
	
		return total;
	}
}
